import React from 'react'
import Loadable from 'react-loadable'

import LoginHigherOrder from '../common/loginComponent'
import LoadingComponent from '../common/loadingComponent'


const TaskmanagerIndicatorsDashboard = Loadable({
  loader: () => import(/*webpackChunkName: 'chunk'*/'./dashboard'),
  loading: () => <LoadingComponent />
});

const Dashboard = () => {
      return  <TaskmanagerIndicatorsDashboard  />  
}

export default LoginHigherOrder(Dashboard)